module.exports = __webpack_public_path__ + "static/media/home_grid_item_3.56ad5974.png";